import styled from 'styled-components';
const StyledInfoContainer = styled.div``;

export default StyledInfoContainer;
